import User from 'entities/User';

let hadWindowUser = false;

export function getWindowUser(): User | undefined | null {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'initialAppData' does not exist on type '... Remove this comment to see the full error message
  const { initialAppData: init } = window;
  // read on app init, so clear it away to prevent re-reading it when it's stale
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'initialAppData' does not exist on type '... Remove this comment to see the full error message
  delete window.initialAppData;

  const userData = init && init.authenticated && init.userData;
  if (userData) {
    hadWindowUser = true;
    return User.fromJSON(userData);
  } else {
    return null;
  }
}

export function logIfUnexpected401() {
  if (hadWindowUser) {
    console.warn('Received 401 after finding a window user');
  }
}
